import { useEffect, useState } from 'react';
import { Alert } from 'react-bootstrap';

import Select from 'react-select';

import ButtonMUI from '@mui/material/Button';
import axios from 'axios';
import { BACKEND_SERVER_URL } from '../../../http/http-config';

import { HiOutlineArrowNarrowRight } from "react-icons/hi";
import { toast } from 'react-toastify';
import { getTestSeries, getTestsForDropdown, setDropDownStyle } from '../CommonHelper';



const ModerateSolution = () => {
    //logic for course lesson 
    const [sectionIds, setSectionIds] = useState({ copyFromSectionId: '', copyInSectionId: '' });
    const [packageIds, setPackageIds] = useState({ copyFromPackageId: '', copyInPackageId: '' });

    const copyLessonHandler = async () => {
        try {
            if (!sectionIds.copyFromSectionId || !sectionIds.copyInSectionId) {
                toast.error("Please Enter Both Section IDS")
                return;
            }
            const resposne = await axios.post(BACKEND_SERVER_URL + '/copyLessonQuestions', sectionIds);
            if (resposne.data.statusCode == 200) {
                toast.success(resposne.data.message)
                setSectionIds({ copyFromSectionId: '', copyInSectionId: '' })
            }
        } catch (error) {
            toast.error(error.resposne.data.message)
        }

    }
    const copyTestHandler = async () => {
        try {
            if (!packageIds.copyFromPackageId || !packageIds.copyInPackageId) {
                toast.error("Please Enter Both Package IDS")
                return;
            }
            const resposne = await axios.post(BACKEND_SERVER_URL + '/copyTestSeriesQuestions', packageIds);
            if (resposne.data.statusCode == 200) {
                toast.success(resposne.data.message)
                setPackageIds({ copyFromPackageId: '', copyInPackageId: '' })
            }
        } catch (error) {
            toast.error(error.resposne.data.message)
        }

    }







    return (
        <>
            <div className="row" >           
                <div className="col-xl-12">
                    <div className="row">
                        <div className="col-xl-12" style={{ zIndex: '0' }}>
                            <div className=" page-title p-2 mb-2">
                                <div className="col-12 ">
                                    <h4 className='text-center text-uppercase'>
                                        <span style={{ fontWeight: 'bold' }}>
                                            Prelims Test Series Questions
                                        </span>
                                    </h4>
                                </div>
                            </div>

                        </div>
                        <div className="col-xl-12 wow fadeInUp" data-wow-delay="1.5s">
                            <div className="table-responsive full-data">
                                <div id="example-student_wrapper" className="dataTables_wrapper no-footer">
                                    <div>
                                        <div className="card h-auto mb-2">
                                            <div className="card-body p-1 pb-1">
                                                <Alert variant="white" className="solid alert-square mb-0">
                                                    <div className='text-primary d-flex justify-content-evenly align-items-center'>
                                                        <div className='col-sm-4'>
                                                            <input
                                                                type="text"
                                                                style={{ display: '' }}
                                                                placeholder='Copy from Package ID'
                                                                value={sectionIds.copyFromPackageId}
                                                                onChange={(e) => setPackageIds((prevData) => ({ ...prevData, copyFromPackageId: e.target.value }))}
                                                                className='form-control' />
                                                        </div>
                                                        <HiOutlineArrowNarrowRight size={35} color='' />
                                                        <div className='col-sm-4'>
                                                            <input
                                                                type="text"
                                                                style={{ display: '' }}
                                                                placeholder='Copy to Package ID'
                                                                value={sectionIds.copyInPackageId}
                                                                onChange={(e) => setPackageIds((prevData) => ({ ...prevData, copyInPackageId: e.target.value }))}
                                                                className='form-control' />
                                                        </div>
                                                        <div className=''>
                                                            <ButtonMUI className='mt-0 pt-1' variant="" size='small' style={{ color: 'white', borderColor: '#4CAF50', backgroundColor: "#10415d" }} onClick={copyTestHandler} >SUBMIT</ButtonMUI>
                                                        </div>

                                                    </div>
                                                </Alert>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-xl-12 mt-5">
                    <div className="row">
                        <div className="col-xl-12" style={{ zIndex: '0' }}>
                            <div className=" page-title p-2 mb-2">
                                <div className="col-12 ">
                                    <h4 className='text-center text-uppercase'>
                                        <span style={{ fontWeight: 'bold' }}>
                                            Course Lesson MCQ
                                        </span>
                                    </h4>
                                </div>
                            </div>

                        </div>
                        <div className="col-xl-12 wow fadeInUp" data-wow-delay="1.5s">
                            <div className="table-responsive full-data">
                                <div id="example-student_wrapper" className="dataTables_wrapper no-footer">
                                    <div>
                                        <div className="card h-auto mb-2">
                                            <div className="card-body p-1 pb-1">
                                                <Alert variant="white" className="solid alert-square mb-0">
                                                    <div className='text-primary d-flex justify-content-evenly align-items-center'>
                                                        <div className='col-sm-4'>
                                                            <input
                                                                type="text"
                                                                style={{ display: '' }}
                                                                placeholder='Copy from Section ID'
                                                                value={sectionIds.copyFromSectionId}
                                                                onChange={(e) => setSectionIds((prevData) => ({ ...prevData, copyFromSectionId: e.target.value }))}
                                                                className='form-control' />
                                                        </div>
                                                        <HiOutlineArrowNarrowRight size={35} color='' />
                                                        <div className='col-sm-4'>
                                                            <input
                                                                type="text"
                                                                style={{ display: '' }}
                                                                placeholder='Copy to Section ID'
                                                                value={sectionIds.copyInSectionId}
                                                                onChange={(e) => setSectionIds((prevData) => ({ ...prevData, copyInSectionId: e.target.value }))}
                                                                className='form-control' />
                                                        </div>
                                                        <div className=''>
                                                            <ButtonMUI className='mt-0 pt-1' variant="" size='small' style={{ color: 'white', borderColor: '#4CAF50', backgroundColor: "#10415d" }} onClick={copyLessonHandler} >SUBMIT</ButtonMUI>
                                                        </div>

                                                    </div>
                                                </Alert>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default ModerateSolution;



